import { stringifyQueryCategories } from './utils/query-params'

export const BASE_PATH = '/'
export const HOME_URL = `${BASE_PATH}`

const ORDER_TOKEN_REG_EXP = '([0-9A-Za-z]{4,8}-[0-9A-Za-z]{2,4}-[0-9A-Za-z]{2,4}-[0-9A-Za-z]{2,4}-[0-9A-Za-z]{4,12})'

/* ===== ACCOUNT ===== */

export const ACCOUNT_URL = '/account/'
export const ACCOUNT_LOGOUT_URL = '/account/logout/'
export const ACCOUNT_LOGIN_URL = '/account/login/'
export const ACCOUNT_CREATE_URL = '/account/create/'
export const ACCOUNT_FORGOT_PASSWORD_URL = '/account/forgot-password/'
export const ACCOUNT_PASSWORD_RESET_URL = '/account/password/reset/:uid/:token/'

/* ===== PROFILE ===== */
export const PROFILE_PATH = '/profile'
export const PROFILE_URL = '/profile/'
export const PROFILE_CHANGE_INFO_URL = '/profile/change-info/'
export const PROFILE_ADDRESSES_URL = '/profile/address-book/'
export const PROFILE_FAVORITES_URL = '/profile/favorites/'
export const PROFILE_ORDER_HISTORY_URL = '/profile/order-history/'
export const PROFILE_SUBSCRIPTIONS_URL = '/profile/subscriptions/'
export const PROFILE_REWARDS_URL = '/profile/rewards/'
export const PROFILE_PATTERN_PACKS_URL = '/profile/pattern-packs/'
export const PROFILE_DISCOUNT_URL = '/profile/discount/'

export const getOrderHistoryUrl = (activeTab: string) => `${PROFILE_ORDER_HISTORY_URL}?activeTab=${activeTab}`

/* ===== CATEGORY ===== */
export const CATEGORY_URL = '/categories/:slug-:id([0-9]+)?/'
export const getCategoryUrl = (slug, id, children: { id: string | number; slug: string }[] | null = null) => {
  return `/categories/${slug}-${id}/${stringifyQueryCategories(children)}`
}

/* ===== PRODUCT ===== */
export const PRODUCT_URL = '/products/:slug-:id([0-9]+)?/'
export const getProductUrl = (slug, id) => {
  return `/products/${slug}-${id}/`
}

export const getProductDashboardUrl = pk => `/dashboard/products/${pk}/`
export const getDownloadAllFiles = orderId => {
  return `/products/order/${orderId}/download_files/`
}
/* ===== CHECKOUT ===== */
export const CHECKOUT_URL = '/checkout/'
export const CART_URL = '/cart/'
export const WHOLESALE_CART_URL = '/cart-wholesale/'
export const WHOLESALE_CHECKOUT_URL = '/checkout-wholesale/'

/* ===== ORDER ===== */
export const ORDER_URL = '/order'
export const ORDER_DETAILS_URL = `/order/:token${ORDER_TOKEN_REG_EXP}/`
export const getOrderDetailsUrl = (token: string) => {
  return `/order/${token}/`
}
export const getOrderGiftCardPdfUrl = token => {
  return `${getOrderDetailsUrl(token)}gift-card-pdf/`
}
export const CHECKOUT_SUCCESS_URL = `/order/:token${ORDER_TOKEN_REG_EXP}/checkout-success/`
export const getCheckoutSuccessUrl = orderToken => `/order/${orderToken}/checkout-success/`
export const getOrderInvoiceUrl = (orderToken: string, fileUrl: string) => `/order-invoice/${orderToken}/${fileUrl}`

/* ===== FLATPAGE ===== */
export const ABOUT_FLATPAGE_URL = '/about'
export const QUICK_LINKS_FLATPAGE_URL = '/quick-links'
export const HELP_URL = '/help'

export const ABOUT_US_FLATPAGE_URL = `${ABOUT_FLATPAGE_URL}/about-us/`
export const PRIVACY_POLICY_FLATPAGE_URL = `${ABOUT_FLATPAGE_URL}/privacy_policy/`
export const REWARDS_TERMS_FLATPAGE_URL = `${ABOUT_FLATPAGE_URL}/rewards_terms_conditions`
export const GIFT_CARD_FAQ_URL = `${ABOUT_FLATPAGE_URL}/gift-card-faq/`
export const GIFT_CARD_TERMS_URL = `${ABOUT_FLATPAGE_URL}/gift-card-terms-conditions/`

export const TRACK_ORDER_URL = `${QUICK_LINKS_FLATPAGE_URL}/order-status`
export const CREDITS_URL = `${PROFILE_PATH}/credits/`
export const GIFT_CARD_URL = `${PROFILE_PATH}/gift-card/`

export const SHIPPING_FLATPAGE_URL = '/product-shipping/'
export const RETURN_FLATPAGE_URL = '/product-return/'
export const PAYMENT_FLATPAGE_URL = '/product-payment/'
export const DOWNLOAD_FLATPAGE_URL = '/product-download/'
export const SHIPPING_DISCOUNT_FLATPAGE_URL = '/free-shipping-program/'

export const HELP_FLATPAGE_URL = '/help'
export const HELP_GENERAL_FLATPAGE_URL = `${HELP_FLATPAGE_URL}/general-information`
export const CONTACT_US_FLATPAGE_URL = `${HELP_FLATPAGE_URL}/contact-us`

/* ===== FEEDBACK ===== */
export const FEEDBACK_URL = `${ABOUT_FLATPAGE_URL}/feedback/`

/* ===== GLOBAL ===== */
export const SEARCH_URL = '/search/'
export const getSearchUrl = (q = '', sale: string[] | number[] = [], promoCode: string[] | number[] = []) => {
  return `${SEARCH_URL}?q=${q}&sale=${sale.join(',')}&promoCode=${promoCode.join(',')}`
}

/* ===== BLOG ===== */

export const BLOG_PATH = '/blog/'
export const BLOG_URL = `${BLOG_PATH}:slug/`
export const BLOG_ARTICLE_URL = `${BLOG_PATH}:blogSlug/:articleSlug/`
export const BLOG_CATEGORY_URL = `${BLOG_PATH}:blogSlug/categories/:categorySlug/`
export const BLOG_ARTICLE_CREATE_URL = `${BLOG_PATH}:blogSlug/categories/:categorySlug/add-article/`
export const BLOG_ARTICLE_LIST_URL = `${BLOG_PATH}:blogSlug/articles/`

export const getBlogUrl = (slug: string) => `${BLOG_PATH}${slug}/`
export const getBlogArticleUrl = (blogSlug: string, slugArticle: string) => `${BLOG_PATH}${blogSlug}/${slugArticle}/`
export const getBlogCategoryUrl = (blogSlug: string, categorySlug: string) =>
  `${BLOG_PATH}${blogSlug}/categories/${categorySlug}/`

export const getAddArticleUrl = (blogSlug: string, categorySlug: string) =>
  `${BLOG_PATH}${blogSlug}/categories/${categorySlug}/add-article/`
export const getArticleListUrl = (blogSlug: string) => `${BLOG_PATH}${blogSlug}/articles/`

export const getLoginUrl = (redirect?: string) => {
  return ACCOUNT_LOGIN_URL + `?redirect=${redirect}`
}

/* ===== COLLECTION ===== */
export const COLLECTION_PATH = '/collections/'
export const COLLECTION_URL = '/collections/:slug/'
export const getCollectionUrl = (slug: string) => {
  return `${COLLECTION_PATH}${slug}/`
}

/* ===== INSPIRATION ===== */

export const INSPIRATION_PATH = `/inspiration/`
export const INSPIRATION_LIST = `${INSPIRATION_PATH}`

/* ===== WHOLESALE ===== */

export const WHOLESALE_PATH = `${BASE_PATH}wholesale`
export const WHOLESALE_ROUTES = {
  HOME: `${WHOLESALE_PATH}`,
  REGISTRATION: `${WHOLESALE_PATH}/registration`,
  PRODUCTS: `${WHOLESALE_PATH}/products`,
  PRODUCT: `${WHOLESALE_PATH}/products/:slug`,
  TERMS: `${WHOLESALE_PATH}/terms`,
  APP_CREATED: `${WHOLESALE_PATH}/app-created`,
  INFORMATION: `${BASE_PATH}wholesaler-info/`,
  BLOG: `${WHOLESALE_PATH}/blog/:slug`,
  BLOG_ARTICLE: `${WHOLESALE_PATH}/blog/:blogSlug/:articleSlug`,
}

export const getWholesaleProductUrl = (slug: string): string => {
  return `${WHOLESALE_ROUTES.PRODUCTS}/${slug}`
}

export const getWholesaleBlogUrl = (slug: string): string => {
  return `${WHOLESALE_PATH}/blog/${slug}`
}
export const getWholesaleBlogArticleUrl = (blogSlug: string, articleSlug: string): string => {
  return `${WHOLESALE_PATH}/blog/${blogSlug}/${articleSlug}`
}

export const getProductsDataSheetDownloadUrl = (pk: string | number): string => {
  return `/products-data-sheet/${pk}`
}

export const PAGE_404_URL = '/not-found/'

export const AFTER_PAY_TERMS_URL = 'https://www.afterpay.com/purchase-payment-agreement'
export const getExternalOrderTrackingUrl = (trackingNumber: string, trackingType: string | null) => {
  if (trackingType === 'fedex') {
    return `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`
  }
  if (trackingType === 'ukrposhta') {
    return `https://t.17track.net/en#nums=${trackingNumber}`
  }
  return `https://t.17track.net/en#nums=${trackingNumber}`
}
